// @storybook-skip: internal section of LessonsExploreScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { TouchableRipple } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import type { LessonViewMode } from "./types";

type Props = {
	viewMode: LessonViewMode;
	onChangeViewMode: (viewMode: LessonViewMode) => void;
};

export const LessonsViewModeToggle = ({
	viewMode,
	onChangeViewMode,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const options = [
		{
			mode: "list" as const,
			icon: "format-list-bulleted" as const,
			label: t("lessons.explore.viewToggle.list"),
		},
		{
			mode: "grid" as const,
			icon: "view-grid-outline" as const,
			label: t("lessons.explore.viewToggle.grid"),
		},
	];

	return (
		<Box
			flexDirection="row"
			borderWidth={1}
			borderColor={theme.colors.outlineVariant}
			borderRadius={theme.roundness * 2}
			overflow="hidden"
		>
			{options.map(({ mode, icon, label }, index) => {
				const selected = viewMode === mode;
				return (
					<TouchableRipple
						key={mode}
						onPress={() => onChangeViewMode(mode)}
						accessibilityRole="button"
						accessibilityLabel={label}
						accessibilityState={{ selected }}
						aria-selected={selected}
						style={{
							backgroundColor: selected
								? theme.colors.secondaryContainer
								: theme.colors.surface,
							borderLeftWidth: index > 0 ? 1 : 0,
							borderLeftColor: theme.colors.outlineVariant,
						}}
					>
						<Box
							width={42}
							height={38}
							alignItems="center"
							justifyContent="center"
						>
							<AppIcon
								name={icon}
								size={24}
								color={
									selected
										? theme.colors.onSecondaryContainer
										: theme.colors.onSurfaceVariant
								}
							/>
						</Box>
					</TouchableRipple>
				);
			})}
		</Box>
	);
};
